<div
  class="pb--8 sticky-sidebar"
  (mouseover)="hover=true"
  (mouseleave)="hover=false"
  #sidebarList
>
  <div
    class="border--all br--default background--light"
    [ngStyle]="{
        minHeight: (height$ | async),
        overflowY: 'auto',
        position: 'relative',
        maxWidth: '300px',
        marginLeft: 'auto'
      }"
  >
    <div
      *ngIf="sections?.length > 1"
      style="position: absolute; width: 100%"
      [@slideInOut]="slideDirection"
      (@slideInOut.done)="slideDirection = 'goLeft'"
    >
      <div
        *ngFor="let section of sections"
        [@slideInOut]="slideDirection"
        #containerDiv
      >
        <ta-sidebar-section
          [section]="section"
          [currentSubsectionId]="currentSubsectionId"
          (currentSubsectionChange)="currentSubsectionChange.emit($event)"
        >
        </ta-sidebar-section>
      </div>
    </div>

    <div
      *ngIf="sections?.length <= 1"
      [@slideInOut]="slideDirection"
      style="position: relative; width: 100%"
    >
      <div
        *ngFor="let section of sections"
        style="position: absolute; width: 100%"
        [@slideInOut]="slideDirection"
      >
        <ta-sidebar-section
          [section]="section"
          [currentSubsectionId]="currentSubsectionId"
          (currentSubsectionChange)="currentSubsectionChange.emit($event)"
        >
        </ta-sidebar-section>
      </div>
    </div>
    <div class="p--3">
      <ng-content></ng-content>
    </div>
  </div>
</div>
